<template>
  <div class="info-card">
    <div class="info-card__field" v-for="(value, name, index) in data" :key="index">
      <div class="info-card__name">
        {{ name }}:
      </div>
      <div class="info-card__cell">
        {{ value }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
    }
  }
}
</script>
<style lang="sass">
.info-card
  .info-card__name
    color: #455058
    font-size: 16px
    margin-right: 21px
    white-space: nowrap
    line-height: 18.75px
    font-weight: 400

  .info-card__cell
    background: #E3EFFA
    padding: 8px
    border-radius: 7px
    flex-grow: 1
    font-size: 16px
    color: #00599B
    line-height: 18.75px
    height: 36px

  .info-card__field
    display: flex
    align-items: center
    margin-bottom: 14px

  .info-card__button
    margin-top: 10px
    margin-left: 10px
</style>
